// modifer: styles/jss/nextjs-material-kit-pro/pages/sectionsSections/teamsStyle
import { cardTitle, description, coloredShadow } from 'styles/jss/original/base';

import tooltipsStyle from 'styles/jss/nextjs-material-kit-pro/tooltipsStyle.js';

const styles = {
  cardTitle: {
    ...cardTitle,
    '@media (max-width: 576px)': {
      marginTop: '0px !important'
    }
  },
  coloredShadow,
  ...tooltipsStyle,
  description: {
    ...description,
    '@media (max-width: 576px)': {
      display: 'none'
    }
  },
  card: {
    textAlign: 'left'
  },
  cardCategory: {
    marginTop: '0',
    '@media (max-width: 640px)': {
      marginTop: '10px'
    }
  },
  cardBody: {
    padding: '0.625rem 0'
  },
  cardFooter: {
    justifyContent: 'flex-end',
    paddingLeft: '0',
    paddingRight: '0',

    '& svg': {
      width: '24px',
      height: '24px'
    }
  },
  flex: {
    display: 'flex'
  }
};

export default styles;
